import './status_page.less';

import * as Campaigns      from '../../campaigns';
import DraftStatusPage     from './draft';
import Navbar              from '../../components/navbar';
import NotFoundPage        from '../../components/not_found_page';
import React               from 'react';
import ScheduledStatusPage from './scheduled';
import SendingStatusPage   from './sending';
import SentStatusPage      from './sent';
import WaitFor             from '../../components/wait_for';


export default function StatusPage({ businessID, campaignID }) {
  const statuses = [
    Campaigns.useCampaignsStatuses(businessID)
  ];
  const campaign = Campaigns.useCampaign(campaignID);

  return (
    <WaitFor statuses={statuses}>
      {campaign && <StatusPageContent {...{ campaign }}/>}
      {!campaign && <NotFoundPage title="Campaign not found."/>}
    </WaitFor>
  );
}


function StatusPageContent({ campaign }) {
  const { status } = campaign;
  return (
    <>
      <Navbar title="Campaign Status"/>
      <div className="page-content">
        {(status === 'draft') && <DraftStatusPage {...{ campaign }}/>}
        {(status === 'scheduled') && <ScheduledStatusPage {...{ campaign }}/>}
        {(status === 'sending') && <SendingStatusPage {...{ campaign }}/>}
        {(status === 'sent') && <SentStatusPage {...{ campaign }}/>}
      </div>
    </>
  );
}
